import React from 'react';

type EyeIconProps = {
  width?: string;
  height?: string;
  color?: string;
};

function EyeIcon({
  width = '29',
  height = '30',
  color = 'black',
}: EyeIconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 29 30'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M2.90454 15.8574C2.74111 15.5986 2.6594 15.4692 2.61366 15.2697C2.5793 15.1198 2.5793 14.8834 2.61366 14.7335C2.6594 14.5339 2.74111 14.4045 2.90454 14.1457C4.25503 12.0074 8.27487 6.60156 14.4009 6.60156C20.5269 6.60156 24.5467 12.0074 25.8972 14.1457C26.0606 14.4045 26.1423 14.5339 26.1881 14.7335C26.2224 14.8834 26.2224 15.1198 26.1881 15.2697C26.1423 15.4692 26.0606 15.5986 25.8972 15.8574C24.5467 17.9958 20.5269 23.4016 14.4009 23.4016C8.27487 23.4016 4.25503 17.9958 2.90454 15.8574Z'
        stroke={color}
        stroke-width='2'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M14.4009 18.6016C16.3891 18.6016 18.0009 16.9898 18.0009 15.0016C18.0009 13.0133 16.3891 11.4016 14.4009 11.4016C12.4126 11.4016 10.8009 13.0133 10.8009 15.0016C10.8009 16.9898 12.4126 18.6016 14.4009 18.6016Z'
        stroke={color}
        stroke-width='2'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
}

export default EyeIcon;
